
// Theme-level vehicle requirement. Direct API requests still require server validation.
window.kgCartGuard = (() => {
  const message = 'Add-ons must be purchased with a vehicle. Please add a vehicle before continuing.';
  const root = () => window.Shopify?.routes?.root || '/';
  let permitted = false;
  async function check() {
    try {
      const response = await fetch(root() + 'cart?kg_validation=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' });
      if (!response.ok) throw new Error('Cart validation failed');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const state = page.querySelector('[data-kg-cart-validation]');
      if (!state || state.dataset.hasVehicle !== 'true') {
        alert(message);
        return false;
      }
      return true;
    } catch (error) {
      console.error('Vehicle cart validation:', error);
      alert('We could not verify your cart. Please refresh the cart and try again.');
      return false;
    }
  }
  function routeToCart(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = document.querySelector('.dummy-checkout');
    if (location.pathname.replace(/\/$/, '').endsWith('/cart') && button) {
      if (button.disabled) alert(message);
      else button.click();
    } else location.assign(root() + 'cart');
  }
  document.addEventListener('click', async event => {
    const target = event.target.closest('button, input, a');
    if (!target) return;
    if (target.matches('[data-kg-remove-orphan]')) {
      event.preventDefault();
      if (target.disabled) return;
      target.disabled = true;
      try {
        const response = await fetch(root() + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: target.dataset.kgRemoveOrphan, quantity: 0 })
        });
        if (!response.ok) throw new Error('Remove failed');
        location.reload();
      } catch (error) {
        target.disabled = false;
        alert('This item could not be removed. Please refresh and try again.');
      }
      return;
    }
    if (permitted || target.matches('.dummy-checkout')) return;
    const href = target.getAttribute('href');
    const checkoutLink = href && /\/checkout(?:[/?#]|$)/.test(href);
    if (target.matches('[name="checkout"], #checkout') || checkoutLink) routeToCart(event);
  }, true);
  document.addEventListener('submit', event => {
    if (permitted) return;
    const form = event.target;
    const checkoutAction = /\/checkout(?:[/?#]|$)/.test(form.getAttribute('action') || '');
    if (checkoutAction || (form.id === 'cart-form' && (!event.submitter || event.submitter.name === 'checkout'))) routeToCart(event);
  }, true);
  return {
    check,
    checkout(button) {
      permitted = true;
      try { button.click(); } finally { permitted = false; }
    }
  };
})();
function runOnStart(cb) {
  if(document.readyState !== 'loading') {
    cb();
  } else {
    document.addEventListener('DOMContentLoaded', cb);
  }
}


let savedLocation = localStorage.getItem("userLocation");
let postcodeLocation = localStorage.getItem("userLocationPostcode");
let cityLocation = localStorage.getItem("userLocationCity");
let stateLocation = localStorage.getItem("userLocationState");
let storeLocation = localStorage.getItem("userLocationStore");
let storeLocationFound = false;

let openBtns, closeBtn, sidebar, overlay, storeBtn, locatorStoreBtns;
let kgTempUserLocation,
  kgTempUserLocationCity,
  kgTempUserLocationPostcode,
  kgTempUserLocationState,
  kgTempUserLocationStore,
  kgTempPostcodeInput;

runOnStart(() => {
  openBtns = document.querySelectorAll('.trigger-location-drawer');
  closeBtn = document.getElementById('kgCloseBtn');
  sidebar = document.getElementById('kgSidebar');
  overlay = document.getElementById('kgOverlay');
  storeBtn = document.getElementById('kgSetStoreBtn');
  locatorStoreBtns = document.querySelectorAll('.locator-set-store-btn');
  // kgDealershipForPickupRadios = document.querySelectorAll(".kg-dealership-for-pickup-radio");
});

// const noneLocationPopup = document.querySelector('.kg-subscribe-main-popup');

const topBarTextLocation = document.querySelectorAll('.kg-deliver-location');
const topBarTextNoneLocation = document.querySelectorAll('.kg-deliver-none-location');

async function askLocation() {
  let coords = { lat: -33.7713052, lng: 151.020996 };

  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        coords = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      },
      function (err) {
        console.error("Error:", err);
      }
    );
  }

  const coordsString = JSON.stringify(coords);

  // Save location
  selectStore(coordsString);

  localStorage.setItem("userLocation", coordsString);
  savedLocation = coordsString;
  kgTempUserLocation = coordsString;

  try {
    // document.querySelector('.kg-subscribe-main-popup').style.display = 'none';
    topBarTextNoneLocation.forEach(el => (el.style.display = 'none'));
    topBarTextLocation.forEach(el => (el.style.display = 'flex'));
    // Reverse geocode using ip-api.com
    const res = await fetch(`https://pro.ip-api.com/json/?key=62D7H3XrHZcOYB5&fields=lat,lon,city,region,regionName,zip,country,countryCode,status`);
    const data = await res.json();
    if (data.status === "success" && data.country == 'Australia') {

      //document.getElementById('kg-postcode-text').innerHTML  = data.city+' '+data.zip;
      //document.getElementById('kg-postcode-text').innerHTML = 'Select your nearest Cub Location Here';
      document.getElementById('kg-postcode-input').value = data.regionName + ' ' + data.city + ' ' + data.zip;

      kgTempUserLocationCity = data.city;
      kgTempUserLocationPostcode = data.zip;
      kgTempUserLocationState = data.regionName;

      localStorage.setItem("userLocationCity", kgTempUserLocationCity);
      cityLocation = kgTempUserLocationCity;
      localStorage.setItem("userLocationPostcode", kgTempUserLocationPostcode);
      postcodeLocation = kgTempUserLocationPostcode;
      localStorage.setItem("userLocationState", kgTempUserLocationState);
      stateLocation = kgTempUserLocationState;

      kgTempPostcodeInput = `${data.regionName} ${data.city} ${data.zip}`;
      topBarTextNoneLocation.forEach(el => (el.style.display = 'none'));

      const checkedRadio = document.querySelector('.kg-store-radio:checked');
      if (checkedRadio) applyStoreSelection(checkedRadio, 'value');
    } else {
      // noneLocationPopup.style.display = 'flex';
      topBarTextLocation.forEach(el => (el.style.display = 'none'));
      topBarTextNoneLocation.forEach(el => (el.style.display = 'flex'));
      console.error("Location lookup failed:", data);
    }
  } catch (error) {
    // noneLocationPopup.style.display = 'flex';
    topBarTextLocation.forEach(el => (el.style.display = 'none'));
    topBarTextNoneLocation.forEach(el => (el.style.display = 'flex'));
    console.error("Reverse geocoding failed:", error);
  }
}

runOnStart(async () => {
  if (!(savedLocation && postcodeLocation)) await askLocation();

  //document.getElementById('kg-postcode-text').innerHTML  = cityLocation+' '+postcodeLocation;
  document.querySelectorAll('.kg-postcode-text-holder').forEach(el => (el.innerHTML = storeLocation));
  document.getElementById('kg-postcode-input').value = stateLocation + ' ' + cityLocation + ' ' + postcodeLocation;
  // document.querySelector('.kg-subscribe-main-popup').style.display = 'none';
  topBarTextNoneLocation.forEach(el => (el.style.display = 'none'));
  topBarTextLocation.forEach(el => (el.style.display = 'flex'));
  selectStore(savedLocation);
});

function selectStore(savedLocation) {
  var i = window.storeLocatorData;

    const excludedDealerKeys = ['FACTORY-HQ', 'CUB-HUNTEROR'];

    i = i.filter(function (store) {
      return !excludedDealerKeys.includes(store.dealer_key);
    });
    
  const { lat, lng } = JSON.parse(savedLocation);
  // const e = 250;
  const e = Infinity;
  var o = _calculateDistance(
    lat,
    lng,
    i
  ).filter(function (t) {
    return t.distance <= e;
  }).sort(function (t, e) {
    return t.distance - e.distance;
  });
  storeHtml(o);
}

function storeHtml(o) {
  storeLocationFound = false;

  document.getElementById('kgSetStoreBtn').setAttribute('disabled', 'disabled');

  const cubShowrooms = o.filter(store => store.type === 'Showroom');
  const dealers = o.filter(store => store.type !== 'Showroom');

  let storeHtml = '';
  if (cubShowrooms.length > 0) {
    // storeHtml += '<h3 class="store-list-subheading">Cub Showrooms</h3>';
    cubShowrooms.forEach((store, index) => {
      storeHtml += getStoreHtml(store, (o.indexOf(store) === 0 && !storeLocationFound) || storeLocation === store.name);
    });
  }

  if (dealers.length > 0) {
    // storeHtml += '<h3 class="store-list-subheading">Dealerships</h3>';
    dealers.forEach((store, index) => {
      storeHtml += getStoreHtml(store, (o.indexOf(store) === 0 && !storeLocationFound) || storeLocation === store.name);
    });
  }

  document.getElementById('kg-store-list').innerHTML = storeHtml;

}

function getStoreHtml(store, isChecked) {
  var checked = ''

  if (isChecked) {
    if (storeLocation === store.name) storeLocationFound = true;
    checked = "checked"
    // localStorage.setItem("userLocationStore", store.name);
    kgTempUserLocationStore = store.name;
    // document.querySelectorAll('.kg-postcode-text-holder').forEach(el => (el.innerHTML = store.name));
  }

  // var googleMapDirection = 'https://www.google.com/maps/dir/current+location/' + store.address_line_1 + ',' + store.city + ',' + store.state + ',' + store.postal_code;
  return `
  <div class="kg-store-item kg-selected"  id="${store.id}" data-store="${store.name}">
          <input type="radio" name="store" class="kg-store-radio" ${checked} value="${store.name}" data-key="${store.dealer_key}" data-lat="${store.latitude}" data-lng="${store.longitude}" data-camper-variant-id="${store.freight_camper_variant}" data-caravan-variant-id="${store.freight_caravan_variant}">
          <div class="kg-store-details">
              <div class="kg-store-name">${store.name}</div>
              <div class="kg-store-address">${store.address_line_1}, ${store.city} ${store.state} ${store.postal_code}</div>
              <div class="kg-store-distance"><em>${store.distance} ${store.distance_units}</em></div>
          </div>
      </div>
  `;
}

// <div class="kg-store-hours">${store.store_time}</div>
//   <div class="kg-store-phone">Phone: ${store.phone}</div>
//   <div class="kg-store-actions">
//       <a href="${googleMapDirection}" target="_blank" class="kg-store-action">Get Directions <span class="icon"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" title="Opens new window" aria-label="Opens new window" aria-describedby="icon-title-ExternalLink" aria-labelledby="icon-title-ExternalLink" titleid="icon-title-ExternalLink"><title>Opens new window </title><g id="Icon/External-link/24px" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M11.9611208,4.36625871 L10.849643,5.60183494 L5.54874903,5.63249887 C4.84046319,5.63249887 4.26537469,6.20970236 4.26537469,6.91948229 L4.26537469,18.4464164 C4.26537469,19.1552945 4.84046319,19.732498 5.54874903,19.732498 L17.051419,19.732498 C17.7597048,19.732498 18.3356933,19.1552945 18.3356933,18.4464164 L18.3356933,13.0666995 L19.4372713,11.924017 L19.600168,11.7607766 L19.600168,18.4464164 C19.600168,19.8533499 18.4571909,20.99964 17.051419,20.99964 L5.54874903,20.99964 C4.14297714,20.99964 3,19.8533499 3,18.4464164 L3,6.91948229 C3,5.51074501 4.14297714,4.36625871 5.54874903,4.36625871 L11.9611208,4.36625871 Z M21,3.00090188 L21,9.12016079 L19.7157257,9.12016079 L19.715,5.195 L11.9443811,12.9848087 L11.0362993,12.0739095 L18.806,4.287 L14.8918222,4.28698341 L14.8918222,3 L21,3.00090188 Z" id="Combined-Shape" fill="#253746"></path></g></svg></span></a>
//       <a href="#" class="kg-store-action">Store details <span class="icon"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true"><title>Icon/Forward/24px</title><g id="Icon/Forward/24px" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><polygon id="Fill-1" fill="#253746" transform="translate(11.992500, 12.000000) rotate(-180.000000) translate(-11.992500, -12.000000) " points="9.975 5 3 11.976 10.024 19 10.976 18.048 5.577 12.648 20.985 12.648 20.985 11.303 5.577 11.303 10.926 5.952"></polygon></g></svg></span></a>
//   </div>

function _calculateDistance(lat, lng, i) {
  var o = { latitude: lat, longitude: lng };
  (i || []).forEach(function (t) {
    const s = 'km'
    var e = ot(o, t, { unit: s });
    t.distance = parseFloat(e.toFixed(e < 10 ? 1 : 0));
    t.distance_units = s;
  });
  return i;
}


function ot(t, e, i) {
  var X = 6371008.8;
  var tt = 0.621371192237334;
  var o = { km: X / 1e3, mi: (X / 1e3) * tt },
    s = (i = i || {}).unit in o ? o[i.unit] : o.km,
    n = et(e.latitude - t.latitude),
    r = et(e.longitude - t.longitude),
    a = et(t.latitude),
    c = et(e.latitude),
    l =
      Math.sin(n / 2) * Math.sin(n / 2) +
      Math.sin(r / 2) * Math.sin(r / 2) * Math.cos(a) * Math.cos(c);
  return s * (2 * Math.atan2(Math.sqrt(l), Math.sqrt(1 - l)));
}

function et(t) {
  return (t * Math.PI) / 180;
}






runOnStart(() => {

  const searchInput = document.getElementById('kg-postcode-input');
  const suggestionBox = document.getElementById('suggestions');

  const searchPopupInput = document.getElementById('kg-postcode-popup-input');
  const suggestionPopupBox = document.getElementById('suggestions-popup');


  const MAPBOX_TOKEN = "pk.eyJ1IjoiY3ViY2FtcGVycyIsImEiOiJjbWRlM2N6dXAwYmpvMmpuYjZkbnBzMDAzIn0.XOsK2ejg66wRSXXqjM6gwg";

  async function getSuggestions(query) {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json?autocomplete=true&country=au,nz&access_token=${MAPBOX_TOKEN}`;
    const res = await fetch(url);
    const data = await res.json();
    return data.features; // array of suggestions
  }

  function showSuggestions(suggestions, suggestionId, searchBox) {
    suggestionId.innerHTML = "";
    suggestions.forEach(suggestion => {
      const li = document.createElement('li');
      li.style.padding = "5px";
      li.style.cursor = "pointer";
      li.classList.add("kg-suggestions-address");
      li.textContent = suggestion.place_name;

      li.addEventListener('click', () => {
        searchBox.value = suggestion.place_name;
        suggestionId.innerHTML = "";

        const [lng, lat] = suggestion.center;
        let parts = suggestion.place_name.split(",").map(part => part.trim());
        let postcode = parts[0];
        let city = parts[1];
        let state = parts[2];


        //document.getElementById('kg-postcode-text').innerHTML  = city+' '+postcode;
        // document.querySelectorAll('.kg-postcode-text-holder').forEach(el => (el.innerHTML = 'Select your nearest Cub Location Here'));
        document.getElementById('kg-postcode-input').value = state + ' ' + city + ' ' + postcode;

        // localStorage.setItem("userLocationCity", city);
        // localStorage.setItem("userLocationPostcode", postcode);
        // localStorage.setItem("userLocationState", state);
        // localStorage.setItem("userLocation", JSON.stringify({ lat, lng }));
        kgTempUserLocationCity = city;
        kgTempUserLocationPostcode = postcode;
        kgTempUserLocationState = state;
        kgTempUserLocation = JSON.stringify({ lat, lng });

        selectStore(kgTempUserLocation);
        // selectStore(JSON.stringify({ lat, lng }));

        console.log("Latitude:", lat, "Longitude:", lng);
      });

      suggestionId.appendChild(li);
    });
  }

  searchInput.addEventListener('input', async e => {
    const value = e.target.value.trim();
    if (value.length > 2) {
      const results = await getSuggestions(value);
      showSuggestions(results, suggestionBox, searchInput);
    } else {
      suggestionBox.innerHTML = "";
    }
  });

  searchPopupInput?.addEventListener('input', async e => {
    const value = e.target.value.trim();
    if (value.length > 2) {
      const results = await getSuggestions(value);
      showSuggestions(results, suggestionPopupBox, searchPopupInput);
    } else {
      suggestionPopupBox.innerHTML = "";
    }
  });
});





/**
   * Core function to apply a selected store
   * sourceEl = the element we're taking data-attrs from (radio or link)
   * nameAttr = which attribute to use for the store name ("value" or "data-name")
   */
  function applyStoreSelection(sourceEl, nameAttr) {
    if (!sourceEl) return;

    // Grab attributes (same names for radios + locator links)
    const lat = sourceEl.getAttribute('data-lat');
    const lng = sourceEl.getAttribute('data-lng');
    const camperVariantId = sourceEl.getAttribute('data-camper-variant-id');
    const caravanVariantId = sourceEl.getAttribute('data-caravan-variant-id');

    // Radios use .value, links use data-name
    const name =
      nameAttr === 'data-name'
        ? (sourceEl.getAttribute('data-name') || sourceEl.textContent.trim())
        : sourceEl.value;

    const oldStoreName = localStorage.getItem('userLocationStore');
    let kgSameLocation = false;

    // Keep existing temp location behaviour for compatibility
    if (typeof kgTempUserLocationCity !== 'undefined') {
      localStorage.setItem('userLocationCity', kgTempUserLocationCity);
      localStorage.setItem('userLocationPostcode', kgTempUserLocationPostcode);
      localStorage.setItem('userLocationState', kgTempUserLocationState);
    }
    if (typeof kgTempUserLocation !== 'undefined') {
      localStorage.setItem('userLocation', JSON.stringify({ kgTempUserLocation }));
    }

    // IF SAME LOCATION THEN SHOW THE DEALERSHIP PICKUP STORE
    const kgLocalStorageDealershipForPickupStore = localStorage.getItem(
      'DealershipForPickupStore'
    );

    if (kgLocalStorageDealershipForPickupStore === oldStoreName) {
      // Show only the selected store's freight block
      document.querySelectorAll('.dealership-pickup-option').forEach((el) => {
        el.style.display = el.dataset.store === name ? 'block' : 'none';
      });

      $('.kg-dealership-for-pickup-radio[value="' + name + '"]')
        .prop('checked', true)
        .trigger('change');

      kgSameLocation = true;
      localStorage.setItem('DealershipForPickupStore', name);
    }

    // Set visible if showroom or selected dealership
    document.querySelectorAll('.dealership-for-pickup').forEach((el) => {
      el.style.display = el.dataset.store === name || el.dataset.type === 'Showroom' ? 'block' : 'none';
    });

    // Save new store + coords
    localStorage.setItem('userLocation', JSON.stringify({ lat, lng }));
    localStorage.setItem('userLocationStore', name);
    storeLocation = name;

    document
      .querySelectorAll('.kg-postcode-text-holder')
      .forEach((el) => (el.textContent = name));

    // Update radio in list
    selectMatchingRadio({ name, lat, lng });

    // Broadcast change
    window.dispatchEvent(
      new CustomEvent('storeChanged', {
        detail: {
          store: { name, caravanVariantId, camperVariantId, kgSameLocation },
        },
      })
    );

    // Close UI if present
    if (typeof sidebar !== 'undefined' && sidebar) {
      sidebar.classList.remove('kg-active');
    }
    if (typeof overlay !== 'undefined' && overlay) {
      overlay.classList.remove('kg-active');
    }
  }

  window.applyStoreSelection = applyStoreSelection;

  /**
   * Ensure the corresponding .kg-store-radio is selected
   * Tries to match by value (store name), then by lat/lng if needed.
   */
  function selectMatchingRadio({ name, lat, lng }) {
    let radio = null;

    if (name) {
      try {
        // CSS.escape for safety if supported
        const safeName = window.CSS && CSS.escape ? CSS.escape(name) : name.replace(/"/g, '\\"');
        radio = document.querySelector(`.kg-store-radio[value="${safeName}"]`);
      } catch (e) {
        radio = document.querySelector(`.kg-store-radio[value="${name}"]`);
      }
    }

    if (!radio && lat && lng) {
      radio = document.querySelector(
        `.kg-store-radio[data-lat="${lat}"][data-lng="${lng}"]`
      );
    }

    if (radio) {
      radio.checked = true;
      // Fire change for any listeners
      radio.dispatchEvent(new Event('change', { bubbles: true }));

      // Toggle selected class on the correct store item
      updateSelectedStoreItemFromEl(radio);
    }

    return radio;
  }

  function updateSelectedStoreItemFromEl(el) {
    if (!el) return;

    const wrapper = el.closest('.kg-store-item');
    if (!wrapper) return;

    document
      .querySelectorAll('.kg-store-item')
      .forEach(item => item.classList.remove('kg-selected'));

    wrapper.classList.add('kg-selected');
  }


runOnStart(() => {
  // Get store
  const store = localStorage.getItem('userLocationStore');

  // Set visible pickup radios if location is saved
  // Set visible if showroom or selected dealership
  document.querySelectorAll('.dealership-for-pickup').forEach((el) => {
    el.style.display = el.dataset.store === store || el.dataset.type === 'Showroom' ? 'block' : 'none';
  });

  console.log('openBtns');
  console.log(openBtns);
  const openOverlay = () => {
    console.log('a');
    sidebar.classList.add("kg-active");
    overlay.classList.add("kg-active");
  }

  for (const openBtn of openBtns) {
    openBtn.addEventListener("click", openOverlay);
  }

  // Close sidebar
  closeBtn.addEventListener("click", function (e) {
    sidebar.classList.remove("kg-active");
    overlay.classList.remove("kg-active");
  });
  // Close sidebar
  overlay.addEventListener("click", function (e) {
    sidebar.classList.remove("kg-active");
    overlay.classList.remove("kg-active");
  });

  document.addEventListener('click', function (e) {
    let storeItem = e.target.closest('.kg-store-item');
    if (storeItem) {
      // Remove kg-selected from all items first
      document.querySelectorAll('.kg-store-item.kg-selected').forEach(el => {
        el.classList.remove('kg-selected');
      });

      // Select the clicked one
      let radio = storeItem.querySelector('.kg-store-radio');
      if (radio) {
        radio.checked = true;
        storeItem.classList.add('kg-selected');
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('kg-store-radio')) {
      document.getElementById('kgSetStoreBtn').removeAttribute('disabled');
    }
  });


  /** Original "Set store" button — uses checked radio */
  if (storeBtn) {
    storeBtn.addEventListener('click', function () {
      const checkedRadio = document.querySelector('.kg-store-radio:checked');
      applyStoreSelection(checkedRadio, 'value');
    });
  }

  /** Locator buttons — use their own data attributes */
  locatorStoreBtns.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      applyStoreSelection(this, 'data-name');
    });
  });

});

$(document).on("change", ".kg-dealership-for-pickup-radio", function () {
  const kgDealershipForPickupRadioLat = $(this).attr("data-lat");
  const kgDealershipForPickupRadioLng = $(this).attr("data-lng");
  const kgDealershipForPickupOption = $(this)
    .closest(".kg-product-upgrade-package-list")
    .find(".dealership-pickup-option");
  const kgDealershipForPickupRadioName = $(this).val();
  localStorage.setItem(
    "DealershipForPickupLocation",
    JSON.stringify({
      kgDealershipForPickupRadioLat,
      kgDealershipForPickupRadioLng,
    })
  );
  localStorage.setItem(
    "DealershipForPickupStore",
    kgDealershipForPickupRadioName
  );
  // console.log("dsfsaffasfasf");
  $(".dealership-pickup-option").hide();
  $(
    ".dealership-pickup-option[data-store='" +
      kgDealershipForPickupRadioName +
      "']"
  ).show();
});

function kgSetBtnLoading($btn, on = true) {
  if (!$btn || !$btn.length) return;

  // inject spinner if missing
  if ($btn.find('.kg-btn-spinner').length === 0) {
    $btn.prepend('<span class="kg-btn-spinner" aria-hidden="true"></span>');
  }

  // toggle loading state
  $btn.toggleClass('is-loading', on)
      .prop('disabled', on)
      .attr('aria-busy', on ? 'true' : 'false');

  // swap the label text inside <text-component>
  const $label = $btn.find('text-component');
  if ($label.length) {
    $label.text(on ? 'Updating' : 'Update');
  }
}



runOnStart(() => {
  let checkoutPending = false;

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.dummy-checkout');
    if (!btn) return;

    e.preventDefault();
    if (checkoutPending) return;

    const kgCustomSignature = document.getElementById('kg-signature-input');
    if (kgCustomSignature && !window.kgSignature?.hasInk) {
      alert('Please provide your signature...');
      return;
    }

    const dealership = localStorage.getItem('userLocationStore');
    const pickup = localStorage.getItem('DealershipForPickupStore');
    if (!dealership) {
      alert('Please Select Your Location...');
      return;
    }
    if (!pickup) {
      alert('Please Select Your Pickup Location...');
      return;
    }

    const originalHtml = btn.innerHTML;
    const originalDisabled = btn.disabled;
    checkoutPending = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    btn.textContent = 'Loading checkout…';

    let checkoutStarted = false;
    function resetLoading() {
      checkoutPending = false;
      btn.disabled = originalDisabled;
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
      btn.innerHTML = originalHtml;
    }

    try {
      if (!await window.kgCartGuard.check()) return;
      if (kgCustomSignature) {
        try {
          await window.kgSignature.ensureSaved();
        } catch (err) {
          console.error('Signature upload failed:', err);
          alert("Your signature couldn't be saved. Please try again.");
          return;
        }
        if (!window.kgSignature?.hasInk || !kgCustomSignature.value) {
          alert('Please provide your signature and wait for it to finish saving.');
          return;
        }
      }

      const attributes = { dealership, pickup };
      if (kgCustomSignature) attributes.Signature = kgCustomSignature.value;

      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes })
      });
      if (!res.ok) throw new Error('Cart update failed: ' + res.status);
      await res.json();

      if (kgCustomSignature && (!window.kgSignature?.hasInk ||
          kgCustomSignature.value !== attributes.Signature)) {
        alert('Your signature changed. Please try checkout again.');
        return;
      }

      const checkout = document.getElementById('checkout');
      if (!checkout || checkout.disabled) throw new Error('Checkout is unavailable.');
      if (!await window.kgCartGuard.check()) return;
      window.kgCartGuard.checkout(checkout);
      checkoutStarted = true;
      window.setTimeout(resetLoading, 12000);
    } catch (err) {
      console.error('Error preparing checkout:', err);
      alert('Something went wrong updating the cart. Please try again.');
    } finally {
      if (!checkoutStarted) resetLoading();
    }
  });
});

$(document).on("click", ".toggle-dealership-pickup", function () {
  const dealershipPickupWrapper = $(".kg-dealership-for-pickup-wrapper");
  // console.log(dealershipPickupWrapper);

  if (dealershipPickupWrapper.length > 0) {
    dealershipPickupWrapper.slideToggle(300);
  }
});


// KG UPGRADES — simple + reliable (Safari-safe)
$(document).on('click', '.kg-product-upgrade-package-toggle', function (e) {
  e.preventDefault();

  const $wrap  = $(this).closest('.kg-product-upgrade-package-content-wrapper');
  const panel  = $wrap.find('.kg-product-upgrade-package-list').first().get(0);
  if (!panel) return;

  const isHidden = window.getComputedStyle(panel).display === 'none';

  $wrap.toggleClass('kg-upgrade-accordion-active', isHidden);
  panel.style.setProperty('display', isHidden ? 'flex' : 'none', 'important');
});

$(document).on("click", ".kg-trigger-edit-options-btn", function () {
  $(".kg-edit-options-btn").trigger("click");

  const kgUpgradeModal = $("#kg-upgrade-modal");
  const kgModalBody = kgUpgradeModal.find(".kg-modal__body");

  kgModalBody.find(".toggle-dealership-pickup").trigger("click");

  setTimeout(() => {
    kgModalBody.animate(
      { scrollTop: kgModalBody[0].scrollHeight },
      500 // duration in ms (adjust for faster/slower scroll)
    );
  }, 600);

  // Get store
  const store = localStorage.getItem('userLocationStore');
  
  // Set visible pickup radios if location is saved
  // Set visible if showroom or selected dealership
  document.querySelectorAll('.dealership-for-pickup').forEach((el) => {
    el.style.display = el.dataset.store === store || el.dataset.type === 'Showroom' ? 'block' : 'none';
  });
});

$(document).on('click', '.kg-edit-options-btn', function() {
  recalcUpgradeAvailability();
});

$(document).on("click", ".kg-product-upgrade-quantity-picker-button", function () {
  const kgTriggerAction = $(this).attr("data-action");
  const kgUpgradeQtyPicker = $(this).closest(".kg-product-upgrade-quantity-picker");
  if (!kgUpgradeQtyPicker.length) return;
  const kgUpgradeQtyInput = kgUpgradeQtyPicker.find(".kg-product-upgrade-quantity-picker-input");
  let kgUpgradeQtyInputValue = parseInt(kgUpgradeQtyInput.val());
  kgTriggerAction === "decrement" ? kgUpgradeQtyInputValue = kgUpgradeQtyInputValue - 1 : kgUpgradeQtyInputValue = kgUpgradeQtyInputValue + 1;
  kgUpgradeQtyInputValue < 0 ? kgUpgradeQtyInput.val(0) : kgUpgradeQtyInput.val(kgUpgradeQtyInputValue);
  kgUpgradeQtyInput.trigger("change");
});

$(document).on("change", ".kg-product-upgrade-quantity-picker-input", function () {
  const thisInput = $(this);

  const kgUpgradeQtyInputValue = parseInt(thisInput.val());
  const maxQty = thisInput.attr('max');

  // Clamp between 0 and max
  thisInput.val(Math.max(0, Math.min(maxQty, kgUpgradeQtyInputValue)));
  
  console.log("Aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa" + thisInput.val());
  kgTriggerUpgradeItemRadio(thisInput);
});

function kgTriggerUpgradeItemRadio(kgQtyInput) {
  const kgMainRadioLabel = kgQtyInput.closest(".kg-product-upgrade-product-item");
  if (!kgMainRadioLabel.length) return;
  const kgLabelForAttr = kgMainRadioLabel.attr("for");
  if (!kgLabelForAttr) return;
  const kgLabelTargetElement = $("#" + kgLabelForAttr);
  if (!kgLabelTargetElement.length) return;

  if (kgQtyInput.val() == 0) {
    kgLabelTargetElement.prop("checked", false);
    kgLabelTargetElement.trigger("change");
    return;
  }
  if (kgQtyInput.val() >= 1) {
    if (!kgLabelTargetElement.prop("checked")) {
      kgLabelTargetElement.prop("checked", true);
      kgLabelTargetElement.trigger("change");
      return;
    }
  }
}

// Returns the selling_plan id (string) for a given line item key, or null
async function getBaseSellingPlanIdByKey(lineKey) {
  try {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
    const baseLine = (cart.items || []).find(it => it.key === lineKey);
    if (!baseLine) return null;

    // Shopify exposes plan in different shapes depending on theme/app
    // Prefer the allocation object, then direct field
    return (
      baseLine.selling_plan_allocation?.selling_plan?.id ??
      baseLine.selling_plan ??
      null
    );
  } catch (e) {
    console.warn('Could not read cart for selling_plan:', e);
    return null;
  }
}



// Add items to cart one-by-one.
// If a selling_plan is provided and Shopify rejects it for that variant,
// we retry once without any selling plan (so one-time purchases still work).
async function kgAddItemsWithSellingPlanFallback(items = []) {
  for (const it of (items || [])) {
    const hasPlan = !!it.selling_plan;

    try {
      await $.ajax({
        url: "/cart/add.js",
        method: "POST",
        dataType: "json",
        data: { items: [it] },
      });
    } catch (err) {
      if (!hasPlan) throw err;

      // Retry without selling_plan
      const { selling_plan, ...noPlanItem } = it;
      await $.ajax({
        url: "/cart/add.js",
        method: "POST",
        dataType: "json",
        data: { items: [noPlanItem] },
      });
    }
  }
}

// UPDATE base+addons from the accordion
$(document).on("click", ".update_line_item_bundle", async function (e) {
  e.preventDefault();
  // console.log("UPDATE base+addons from the accordion");

  const $btn = $(this);

  // Guard against double click
  if ($btn.prop("disabled") || $btn.hasClass("is-loading")) return;

  // Turn on spinner & disable
  kgSetBtnLoading($btn, true);

  let shippingItem;

  const $section = $btn.closest(".kg-product-upgrades-section");
  const kgBaseProductId = $btn.attr("data-base-product-id");
  const kgBaseProductKey = $btn.attr("data-base-product-key");

  // UI loading state
  const $table = $(".cart-items__table");
  $table.find("text-component").attr("shimmer", true);

  // --- helpers ---
  const decodeHtml = (s) => {
    if (!s) return "";
    return /&quot;|&amp;|&#/.test(s) ? $("<textarea/>").html(s).text() : s;
  };
  const safeParse = (s, fallback = []) => {
    try {
      return JSON.parse(s);
    } catch {
      return fallback;
    }
  };
  const isNumericId = (v) => /^\d+$/.test(String(v));

  // Parse existing bundle items in cart (children array from Liquid)
  const rawJson = decodeHtml($btn.attr("data-upgrade-json") || "");
  const oldUpgradeJson = Array.isArray(safeParse(rawJson))
    ? safeParse(rawJson)
    : [];

  console.log(JSON.stringify(oldUpgradeJson, null, 2), "OLD UPGRADE JSON");
  
// Collect selected inputs (radio + checkbox) and keep ONLY numeric variant ids
// Also read optional per-addon selling plan directives:
//   - data-selling-plan="none"      -> force no plan for that addon (one-time)
//   - data-selling-plan="inherit"   -> inherit base item's selling plan
//   - data-selling-plan-id="12345"  -> use this explicit selling plan id
const $checkedInputs = $section.find(
  "input.kg-product-upgrade-package-radio:checked, input.kg-product-upgrade-package-checkbox:checked, input.kg-dealership-for-pickup-radio:checked"
);

const addonPlanByVariantId = {};
$checkedInputs.each(function () {
  const $inp = $(this);
const rawVal = $inp.hasClass("kg-dealership-for-pickup-radio")
  ? ($inp.attr("data-value") ||
     $inp.closest("label").attr("data-variant-id") ||   // <-- YOUR HTML HAS THIS
     $inp.closest(".dealership-for-pickup").attr("data-variant-id"))
  : $inp.val();

  if (!isNumericId(rawVal)) return;
  const variantId = Number(rawVal);

  const explicitPlan =
    $inp.attr("data-selling-plan-id") ||
    $inp.attr("data-selling_plan_id") ||
    $inp.data("sellingPlanId") ||
    $inp.data("selling-plan-id");

  // IMPORTANT: For add-ons we NEVER inherit the base item's selling plan.
  // If the input has an explicit plan id, we use it; otherwise we send no selling_plan.
  addonPlanByVariantId[variantId] =
    explicitPlan && isNumericId(explicitPlan) ? String(explicitPlan) : null;
});
const selectedValues = $checkedInputs
  .map(function () {
    if ($(this).hasClass("kg-dealership-for-pickup-radio")) {
      console.log($(this).attr("data-value"));
      return $(this).attr("data-value");
    } else {
      return $(this).val();
    }
  })
  .get()
  .filter((v) => isNumericId(v)) // drop "none" and anything non-numeric
  .map((v) => Number(v));

  // Determine items to remove vs add
  // oldUpgradeJson: [{id:<variantId>, key:<line_key>, quantity:<qty>}]
  const remaining = [...oldUpgradeJson];
  const itemsToAdd = [];

  selectedValues.forEach((val) => {
    const idx = remaining.findIndex((old) => Number(old.id) === val);
    const kgOldItemQuantity = idx !== -1 ? remaining[idx].quantity : 1;
    const kgNewItemQuantity = kgGetUpgradeQuantity($(".kg-update-upgrade-quantity-input-" + val));
    if (idx !== -1 && kgOldItemQuantity === kgNewItemQuantity) {
      // already in cart -> keep; remove from "remaining"
      remaining.splice(idx, 1);
    } else {
      // new selection
      itemsToAdd.push({ id: val, quantity: kgNewItemQuantity });
    }
  });

  // STEP 1: Remove old/unselected child lines by KEY -> set to 0
  let updatesPayload = {};
  remaining.forEach((item) => {
    // // Skip removing freight to dealer
    // if (item.product_id === 9054288052463) {
    //   shippingItem = item;
    //   return;
    // }
    if (item && item.key) updatesPayload[item.key] = 0; // remove
  });

  // Also: if your Radio group now has "None" selected (no numeric radios checked),
  // remaining already contains the previously selected radio child; this removes it.

  try {
    if (Object.keys(updatesPayload).length > 0) {
      await $.ajax({
        url: "/cart/update.js",
        method: "POST",
        dataType: "json",
        data: { updates: updatesPayload }, // jQuery serializes as updates[<key>]=0
      });
    }
  } catch (err) {
    console.error("Cart update (remove) failed:", err?.responseText || err);
    $table.find("text-component").attr("shimmer", false);
    return;
  }

  console.log('remaining:', JSON.stringify(remaining, null, 2));
  console.log('selectedValues:', JSON.stringify(selectedValues, null, 2));
  console.log('updatesPayload:', JSON.stringify(updatesPayload, null, 2));

  // return;

  // STEP 2: Add new child items (attach to BASE LINE KEY; hide in cart row UI)
  if (itemsToAdd.length > 0) {
    const itemsWithProps = itemsToAdd.map((item) => {
      const addonPlanId = addonPlanByVariantId[item.id]; // string or null

      return {
        id: item.id,
        quantity: item.quantity,
        ...(addonPlanId ? { selling_plan: String(addonPlanId) } : {}),
        properties: {
          __ischildof: kgBaseProductId, // legacy link (keep if you already use it)
          _hide_in_cart: "true", // hide child rows in UI
        },
      };
    });

    try {
      // Add items individually so a selling-plan mismatch on one addon doesn't block the rest.
      await kgAddItemsWithSellingPlanFallback(itemsWithProps);
    } catch (err) {
      console.error("Cart add (children) failed:", err?.responseText || err);
      $table.find("text-component").attr("shimmer", false);
      return;
    }
  }

  // STEP 3: Update base line properties (persist selections for Liquid)
  // STEP 3: Update base line properties (persist selections for Liquid)
  try {
    // Build: { "Upgrade Packs": "OFF GRID PACK ...", "Drawbar Options": "Cruisemaster ...", "__selected_upgrade_ids": "451...:upgrade-packs,451...:drawbar-options", "__isparent": "true" }
    const propertiesObj = {
      __isparent: "true",
      _limit_one: "true",
      _allow_only: "vehicle",
    };
    const selectedIdsWithGroup = [];

    // Each option group wrapper
    $section
      .find(".kg-product-upgrade-package-content-wrapper")
      .each(function () {
        const $group = $(this);
        const groupTitle = $group
          .find(".kg-product-upgrade-package-toggle-title")
          .first()
          .text()
          .trim();
        const groupHandle = (
          $group
            .find(".kg-product-upgrade-package-toggle-title")
            .first()
            .data("handleize") || ""
        )
          .toString()
          .trim();

        if (!groupTitle || !groupHandle) return;

        // Selected inputs within this group
        const $checked = $group.find(
          "input.kg-product-upgrade-package-radio:checked, input.kg-product-upgrade-package-checkbox:checked"
        );
        if (!$checked.length) return;

        // Collect human labels + ids for this group
        const titles = [];
        $checked.each(function () {
          const $inp = $(this);
          const val = $inp.val();

          // skip "none" radios
          if (!/^\d+$/.test(String(val))) return;

          const variantId = Number(val);
          const title = ($inp.data("upgrade-title") || $inp.data("title") || "")
            .toString()
            .trim();

          if (title) titles.push(title);
          selectedIdsWithGroup.push(`${variantId}:${groupHandle}`);
        });

        // Set group → label(s) (join multiple checkbox selections)
        if (titles.length) {
          propertiesObj[groupTitle] = titles.join(", ");
        }
      });


    propertiesObj["Preferred Dealership"] = localStorage.getItem("userLocationStore");
    propertiesObj["Delivery to Dealership"] = localStorage.getItem("DealershipForPickupStore");

    // Persist CSV of ids with :group-handle (what your Liquid expects)
    propertiesObj["__selected_upgrade_ids"] = selectedIdsWithGroup.join(",");

    if (kgBaseProductKey) {
      await $.ajax({
        url: "/cart/change.js",
        method: "POST",
        dataType: "json",
        data: {
          id: kgBaseProductKey,
          // omit quantity to leave it unchanged
          properties: propertiesObj,
        },
      });
    }
  } catch (err) {
    console.error("Cart change (base props) failed:", err?.responseText || err);
    $(".cart-items__table").find("text-component").attr("shimmer", false);
    return;
  }

  // STEP 4: refresh UI
  try {
    if (typeof window.kgRefreshFullCart === "function") {
      await window.kgRefreshFullCart();
    } else {
      window.location.reload();
    }
  } finally {
    $table.find("text-component").attr("shimmer", false);
  }
});



// CUSTOM CART ITEM REMOVE BUTTON 
$(document).on("click", ".kg-cart-custom-remove-button", async function () {
  const $row = $(this).closest("tr.cart-items__table-row");
  if (!$row.length) return;

  // Read data from the row (works even when modal/accordion is not mounted)
  const baseKey = $row.attr("data-base-key");
  const raw = $row.attr("data-children") || "[]";

  // HTML-decoding in case Liquid escaped quotes
  const decodeHtml = (s) => (/&quot;|&amp;|&#/.test(s) ? $("<textarea/>").html(s).text() : s);
  let children = [];
  try { children = JSON.parse(decodeHtml(raw)); } catch { children = []; }

  if (!baseKey) {
    console.error("Missing baseKey on row");
    return;
  }

  // Build updates: remove base and all its child keys (if any)
  const updatesPayload = { [baseKey]: 0 };
  children.forEach((c) => { if (c && c.key) updatesPayload[c.key] = 0; });

  try {
    await $.ajax({
      url: "/cart/update.js",
      method: "POST",
      dataType: "json",
      data: { updates: updatesPayload },
      success: () => kgRefreshFullCart(),
    });
  } catch (err) {
    console.error("Cart update failed:", err?.responseText || err);
  }
});


$(document).on("click", ".kg-toggle-children", function () {
  const $kgWrapper = $(this).closest(".kg-parent-item-wrapper");
  const $kgChildContainer = $kgWrapper.find(".kg-cart-bundle-child-items-wrapper");
  const $kgToggleText = $(this).find(".kg-toggle-text");
  const $kgIcon = $(this).find(".kg-toggle-icon");

  $kgChildContainer.slideToggle(200);
  $kgWrapper.toggleClass("kg-active");

  if ($kgWrapper.hasClass("kg-active")) {
    $kgToggleText.text("Hide");
    $kgIcon.text("–");
  } else {
    $kgToggleText.text("Show");
    $kgIcon.text("+");
  }
});

window.addEventListener("storeChanged", async ({ detail }) => {
  console.log("store changed");

  const store = detail.store;
  const kgPreferredDealershipStore = localStorage.getItem("userLocationStore");
  const kgDealershipForPickupStore = localStorage.getItem(
    "DealershipForPickupStore"
  );
  const kgSameLocation = store.kgSameLocation || false;

  // console.log(kgSameLocation, "dddddddddddddddddddddd");
  // // Load cart
  const cart = await fetch("/cart.js", { credentials: "same-origin" }).then(
    (r) => r.json()
  );

  const vehicleItem = cart.items.find((item) =>
    ["caravan", "camper"].includes(item.product_type.toLowerCase())
  );
  if (!vehicleItem) return;
  const kgBaseProductKey = vehicleItem.key;

  const $table = $(".cart-items__table");
  $table.find("text-component").attr("shimmer", true);

  const freightKey =
    (vehicleItem.product_type || "").toLowerCase() === "caravan"
      ? (vehicleItem.properties?._freight_key || vehicleItem.properties?.freight_key)
      : (vehicleItem.properties?._freight_key || vehicleItem.properties?.freight_key);
  const dealerId = store.dealerId || store.dealer_id || store.id;
  const freightTitle = `${String(dealerId).toUpperCase().trim()} / ${String(freightKey || "").trim()}`;

  // Find matching freight variant by title from DOM rendered by Liquid
  const $match = $(
    `.freight-option[data-dealer-id="${String(dealerId).toUpperCase().trim()}"][data-freight-key="${String(freightKey || "").trim()}"],` +
    `.dealership-pickup-option[data-dealer-id="${String(dealerId).toUpperCase().trim()}"][data-freight-key="${String(freightKey || "").trim()}"],` +
    `.dealership-for-pickup[data-dealer-id="${String(dealerId).toUpperCase().trim()}"][data-freight-key="${String(freightKey || "").trim()}"]`
  ).first();

  const freightVariantId = Number($match.data("variant-id")) || null;
  const deliveryToDealershipProductId = 9234842124527; // single freight product

  if (!freightVariantId) return;

  if (kgSameLocation) {
    const freightItem = cart.items.find((item) => item.product_id === deliveryToDealershipProductId);
    if (!freightItem || !vehicleItem) return;
    // console.log("Found freight item");
    // console.log("store", store);
    // console.log(`Vehicle is a ${vehicleType}`);
    // console.log("Freight variant id:", freightVariantId);

    // Set current freight line to 0 (remove)
    const updates = { [freightItem.key]: 0 };

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
      credentials: "same-origin",
    });

    console.log(updates, "UPDATED FREIGHT IN SAME LOCATION");

    // STEP 2: Add new freight item

    const basePlanId =
      vehicleItem?.selling_plan_allocation?.selling_plan?.id
        ? String(vehicleItem.selling_plan_allocation.selling_plan.id)
        : (vehicleItem?.selling_plan ? String(vehicleItem.selling_plan) : null);

    const newFreight = [{
      id: freightVariantId,
      quantity: 1,
      ...(basePlanId ? { selling_plan: basePlanId } : {}),
      properties: {
        __ischildof: vehicleItem.product_id,
        _hide_in_cart: "true",
      },
    }];

    try {
      await kgAddItemsWithSellingPlanFallback(newFreight);

    } catch (err) {
      console.error("Cart add (children) failed:", err?.responseText || err);
      $table.find("text-component").attr("shimmer", false);
      return;
    }
    console.log(newFreight, "ADDED FREIGHT IN SAME LOCATION");
  }


  // STEP 3: Update base line properties to replace with new freight
  try {
    const propertiesObj = vehicleItem.properties;

    // replace property
    const upgradeIds = propertiesObj["__selected_upgrade_ids"].split(",");
    const indexOfFreight = upgradeIds.findIndex((item) =>
      item.endsWith(":Delivery to Dealership")
    );

    if (kgSameLocation) {
      if (indexOfFreight < 0)
        upgradeIds.push(`${freightVariantId}:Delivery to Dealership`);
      else
        upgradeIds[
          indexOfFreight
        ] = `${freightVariantId}:Delivery to Dealership`;
    }

    propertiesObj["__selected_upgrade_ids"] = upgradeIds.join(",");

    // Add shipping
    propertiesObj["Preferred Dealership"] = store.name;
    propertiesObj["Delivery to Dealership"] =
      localStorage.getItem("DealershipForPickupStore") || store.name;

    // Persist CSV of ids with :group-handle (what your Liquid expects)
    console.log(propertiesObj, "cccccccccccccccc");
    if (kgBaseProductKey) {
      await $.ajax({
        url: "/cart/change.js",
        method: "POST",
        dataType: "json",
        data: {
          id: kgBaseProductKey,
          // omit quantity to leave it unchanged
          properties: propertiesObj,
        },
      });
    }
  } catch (err) {
    console.error("Cart change (base props) failed:", err?.responseText || err);
    $(".cart-items__table").find("text-component").attr("shimmer", false);
    return;
  }

  // console.log(kgBaseProductKey, "KG BASE PRODUCT KEY");
  // console.log(propertiesObj, "CHANGED BASE PROPERTIES");
  // return;

  // STEP 4: refresh UI
  try {
    if (typeof window.kgRefreshFullCart === "function") {
      await window.kgRefreshFullCart();
    } else {
      // window.location.reload();
    }
  } finally {
    $table.find("text-component").attr("shimmer", false);
  }
});

// ===== CART REFRESH FUNCTIONS =====
// Refresh cart using theme's method (no page reload)
function kgRefreshFullCart() {
  // Trigger theme's cart update event
  const cartUpdateEvent = new CustomEvent('cart:update', {
    bubbles: true,
    detail: {
      resource: {},
      sourceId: 'kg-custom',
      data: {
        source: 'kg-custom',
        sections: {}
      }
    }
  });
  document.dispatchEvent(cartUpdateEvent);
  $(".cart-items__table").find("text-component").attr("shimmer", false);
}

// KG UPGRADES PRODUCT COMMON CSS 
function kgGetUpgradeQuantity(kgTargetElement) {
  const kgUpgradeItemWrapper = kgTargetElement.closest(".kg-product-upgrade-product-item");
  if (!kgUpgradeItemWrapper.length) return 1;
  const kgUpgradeQtyInput = kgUpgradeItemWrapper.find(".kg-product-upgrade-quantity-picker-input");
  if (!kgUpgradeQtyInput.length) return 1;
  return parseInt(kgUpgradeQtyInput.val());
}

function kgUpdateQuantityInput(kgTargetElement) {
  const kgMainRadioLabel = kgTargetElement.closest(".kg-product-upgrade-product-item");
  if (!kgMainRadioLabel.length) return;
  const kgQuantityInput = kgMainRadioLabel.find(".kg-product-upgrade-quantity-picker-input");
  if (!kgQuantityInput.length) return;
  if (!kgTargetElement.prop("checked")) {
    kgQuantityInput.val(0);
    return;
  }
  if (kgTargetElement.prop("checked") && kgQuantityInput.val() <= 0) {
    kgQuantityInput.val(1);
    return;
  }
}

function recalcUpgradeAvailability() {
  const $allInputs = $('.kg-product-upgrade-package-checkbox, .kg-product-upgrade-package-radio');

  function normaliseToArray(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value;

    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function cleanUpgradeId(id) {
    id = String(id || '');
    return id.includes('-') ? id.split('-')[0] : id;
  }

  function setDisabledMessage($input, msg) {
    const $info = $input.siblings('.kg-product-upgrade-product-info-content');
    const $price = $input.siblings('.kg-product-upgrade-product-price');

    if ($info.length) {
      $info.find('.kg-product-upgrade-disabled-note').text(msg || '');
    } else if ($price.length) {
      if (msg) {
        $price.addClass('kg-tooltip');
        $price.children('.kg-tooltiptext').text(msg);
      } else {
        $price.removeClass('kg-tooltip');
        $price.children('.kg-tooltiptext').text('');
      }
    }
  }

  function joinTitles(titles) {
    if (!titles.length) return '';
    if (titles.length === 1) return titles[0];
    if (titles.length === 2) return `${titles[0]} or ${titles[1]}`;
    return `${titles.slice(0, -1).join(', ')}, or ${titles[titles.length - 1]}`;
  }

  // 1. Build upgradeId -> title lookup
  const titleLookupGlobal = {};
  const titleLookupBySlot = {};

  $allInputs.each(function () {
    const $input = $(this);
    const upgradeId = cleanUpgradeId($input.data('upgrade-id') || $input.val());
    const title = $input.data('title') || '';
    const slot = $input.closest('td[data-slot]').data('slot');

    if (title) {
      titleLookupGlobal[upgradeId] = title;

      if (slot !== undefined) {
        if (!titleLookupBySlot[slot]) titleLookupBySlot[slot] = {};
        titleLookupBySlot[slot][upgradeId] = title;
      }
    }
  });

  // 2. Gather all selected inputs
  const $selected = $allInputs.filter(':checked');

  // 3. Build selected lookup sets
  const selectedGlobal = new Set();
  const selectedBySlot = {};

  $selected.each(function () {
    const $sel = $(this);
    const upgradeId = cleanUpgradeId($sel.data('upgrade-id') || $sel.val());
    const slot = $sel.closest('td[data-slot]').data('slot');

    selectedGlobal.add(upgradeId);

    if (slot !== undefined) {
      if (!selectedBySlot[slot]) selectedBySlot[slot] = new Set();
      selectedBySlot[slot].add(upgradeId);
    }
  });

  // 4. Build exclusion map: target key -> [titles that block it]
  const blockedBy = {};

  $selected.each(function () {
    const $sel = $(this);
    const title = $sel.data('title') || '';
    const slot = $sel.closest('td[data-slot]').data('slot');
    const exclusions = normaliseToArray($sel.data('exclusions'));

    exclusions.forEach(id => {
      const cleanedId = cleanUpgradeId(id);
      const key = slot !== undefined ? `${slot}::${cleanedId}` : cleanedId;

      if (!blockedBy[key]) blockedBy[key] = [];
      if (title && !blockedBy[key].includes(title)) {
        blockedBy[key].push(title);
      }
    });
  });

  // 5. Evaluate each input against both rules
  $allInputs.each(function () {
    const $input = $(this);
    const upgradeId = cleanUpgradeId($input.data('upgrade-id') || $input.val());
    const slot = $input.closest('td[data-slot]').data('slot');
    const key = slot !== undefined ? `${slot}::${upgradeId}` : upgradeId;

    const blockers = blockedBy[key] || [];
    const onlySelectableWith = normaliseToArray($input.data('only-selectable-with')).map(cleanUpgradeId);

    // RULE 1: exclusions take priority
    if (blockers.length) {
      const msg = blockers.length === 1
        ? `Option unavailable while ${blockers[0]} is selected`
        : `Option unavailable while ${blockers.join(' and ')} are selected`;

      $input.prop('checked', false).prop('disabled', true);
      setDisabledMessage($input, msg);
      return;
    }

    // RULE 2: only-selectable-with applies if present
    if (onlySelectableWith.length) {
      let isAllowed = false;

      if (slot !== undefined) {
        const slotSelections = selectedBySlot[slot] || new Set();
        isAllowed = onlySelectableWith.some(id => slotSelections.has(id));
      } else {
        isAllowed = onlySelectableWith.some(id => selectedGlobal.has(id));
      }

      if (!isAllowed) {
        const titleSource = slot !== undefined
          ? (titleLookupBySlot[slot] || {})
          : titleLookupGlobal;

        const requiredTitles = onlySelectableWith
          .map(id => titleSource[id] || titleLookupGlobal[id] || null)
          .filter(Boolean);

        const readableTitles = joinTitles(requiredTitles);

        const msg = readableTitles
          ? `Option only available when ${readableTitles} is selected`
          : `Option only available when a required addon is selected`;

        $input.prop('checked', false).prop('disabled', true);
        setDisabledMessage($input, msg);
        return;
      }
    }

    // RULE 3: otherwise enabled
    $input.prop('disabled', false);
    setDisabledMessage($input, '');
  });
}

$(document).on('change', '.kg-product-upgrade-package-checkbox, .kg-product-upgrade-package-radio', function () {
  kgUpdateQuantityInput($(this));
  recalcUpgradeAvailability();
});

runOnStart(() => {
  recalcUpgradeAvailability();
});
